import type { ReactNode } from 'react'
import React, { Children, cloneElement, isValidElement, useState } from 'react'

import { ButtonClean } from '@fourthwall/components'

import * as S from './styled'
import type { ConcealedTextProps } from './types'

export const ConcealedText = ({
  hideLabel,
  showLabel,
  defaultHidden = true,
  hiddenColor = '#D9D9D9',
  children,
}: ConcealedTextProps) => {
  const [isHidden, setIsHidden] = useState(defaultHidden)

  const wrapNode = (node: ReactNode) => {
    if (!node) {
      return node
    }

    return <S.Wrapper>{node}</S.Wrapper>
  }

  const mapChildren = (nodes: ReactNode): any => {
    return Children.map(nodes, (node: any) => {
      if (!isValidElement(node)) {
        return wrapNode(node)
      }
      if ((node.props as any).children) {
        return cloneElement(node, {
          // @ts-ignore
          children: mapChildren(node.props.children),
        })
      }

      return node
    })
  }

  const toggleHidden = () => setIsHidden(!isHidden)
  const label = isHidden ? showLabel : hideLabel

  return (
    <>
      <S.Content $isHidden={isHidden} $hiddenColor={hiddenColor}>
        {mapChildren(children)}
      </S.Content>
      <ButtonClean key={label} onClick={toggleHidden} label={label} />
    </>
  )
}
